import { APP_KEYS } from '@qms360/shared';

/**
 * Where to go after signing in or changing a password (pass 9). The page the
 * person was sent away from, if there was one; otherwise the first app they
 * hold any permission in — it used to be QA/QC for everyone, which dropped a
 * field engineer on a screen of refusals.
 */
export function landingPath(capabilities: Record<string, string[]> | undefined, from?: unknown): string {
  if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('/login') && !from.startsWith('//')) {
    return from;
  }
  const first = APP_KEYS.find((app) => (capabilities?.[app] ?? []).length > 0);
  return `/${first ?? 'qaqc'}`;
}
